"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGenerator = exports.createForm = exports.createFormMeta = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any */
var lodash_1 = __importDefault(require("lodash"));
var Yup = __importStar(require("yup"));
var FormInput_1 = require("./FormInput");
var createFormMeta = function (formInputs) {
    var initValues = {};
    var yupShape = {};
    formInputs.forEach(function (input) {
        if (input.type !== 'element') {
            if (input.type === 'array') {
                var childShape_1 = {};
                input.props.elements.forEach(function (childInput) {
                    if (childInput.type !== 'array' && childInput.type !== 'element') {
                        childShape_1[childInput.props.name] = childInput.validation;
                    }
                });
                lodash_1.default.set(initValues, input.props.name, []);
                yupShape[input.props.name] = Yup.array().of(Yup.object().shape(childShape_1));
            }
            else {
                lodash_1.default.set(initValues, input.props.name, input.initValue);
                yupShape[input.props.name] = input.validation;
            }
        }
    });
    return {
        initValues: initValues,
        validateSchema: Yup.object().shape(yupShape),
    };
};
exports.createFormMeta = createFormMeta;
var createForm = function (formConfig) { return ({
    Element: function () { return (0, jsx_runtime_1.jsx)(exports.FormGenerator, { formConfig: formConfig }); },
    meta: (0, exports.createFormMeta)(formConfig),
}); };
exports.createForm = createForm;
var FormGenerator = function (_a) {
    var formConfig = _a.formConfig;
    var elements = formConfig.map(function (form) {
        var input = FormInput_1.FormInputs.find(function (i) { return i.type === form.type; });
        if (!input)
            throw new Error('FormGenerator error: Cannot find input');
        return ((0, react_1.createElement)(input.Element, __assign({}, form.props, { key: form.props.name, id: form.props.id || form.props.name })));
    });
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: elements });
};
exports.FormGenerator = FormGenerator;
